import React, { Component } from 'react'
import StnResults from './StnResults'
import Summary from './Summary'
import GetResults from './GetResults'
import Footer from './Footer'

export default class App extends Component {

  constructor(props) {
    super(props)
    this.state = {
      qcVar: "",
      stnId: "",
      qcresults: ""
    } 
  }

  qcVarNames = {
    rhum: "Relative Humidity",
    temp: "Temperature",
    srad: "Solar Radiation",
    pcpn: "Precipitation"
  }

  changeState = (newState) => {
    this.setState(newState)
  }

  render() {
    return (
      <div style={{fontFamily:"'Open Sans', sans-serif", fontSize:"80%"}}>
        <h3>NEWA Data Quality Control Manager</h3>
        <GetResults qcVarNames={this.qcVarNames} changeState={this.changeState}  />
        {this.state.qcresults && <Summary qcresults={this.state.qcresults} qcVarName={this.qcVarNames[this.state.qcVar]} changeState={this.changeState} />}
        {this.state.stnId && <StnResults qcresults={this.state.qcresults[this.state.stnId]} qcVar={this.state.qcVar} stnId={this.state.stnId} />}
        <Footer />
      </div>
    )
  }
}


// WEBPACK FOOTER //
// ./src/App.js